import React, { Component } from "react";
import { observer } from "mobx-react";

import { defined } from "@formant/core/common/defined";
import { duration } from "@formant/core/model/duration";

import {
    deviceStore,
    rtcSignalingStore,
    signalingStore,
} from "../../../stores";
import { Timer } from "../../common/Timer";
import { TeleopList } from "./TeleopList";

interface ITeleopListDataProps {
    onClose: () => void;
}

interface ITeleopListDataState {
    deviceOwnersV2: Map<string, string | undefined>;
    deviceOwnersV1: Map<string, string | undefined>;
    devices: any[];
    loading: boolean;
}

@observer
export class TeleopListData extends Component<
    ITeleopListDataProps,
    ITeleopListDataState
> {
    constructor(props: ITeleopListDataProps) {
        super(props);
        this.state = {
            deviceOwnersV2: new Map(),
            deviceOwnersV1: new Map(),
            devices: [],
            loading: true,
        };
    }

    public async componentDidMount() {
        await this.onTick();
    }

    public componentWillUnmount() {
        const { deviceOwnersV2, deviceOwnersV1 } = this.state;
        deviceOwnersV2.clear();
        deviceOwnersV1.clear();
    }

    private onTick = async () => {
        await rtcSignalingStore.fetchSessions();
        await rtcSignalingStore.fetchPeers();
        await signalingStore.fetchPeers();
        await deviceStore.fetchList();

        // get device peers from both v1 and v2 signaling stores
        const v1Peers = rtcSignalingStore.peerDevices({
            onlyTeleopable: true,
        });
        const v2Peers = signalingStore.peerDevices();

        const allDevices = [...(v1Peers ?? []), ...(v2Peers ?? [])];

        // reset the maps
        const { deviceOwnersV2, deviceOwnersV1 } = this.state;
        deviceOwnersV2.clear();
        deviceOwnersV1.clear();

        for (const device of allDevices) {
            const userPeersV2 =
                await signalingStore.userPeersInTeleopSessionWithDevice(device);
            const ownerIdV2 = userPeersV2
                ?.find(_ => _)
                ?.getUserId()
                ?.getValue();
            deviceOwnersV2.set(defined(device.id), ownerIdV2);

            const ownerIdV1 =
                rtcSignalingStore.ownerPeerForDeviceTeleop(device)?.userId;
            deviceOwnersV1.set(defined(device.id), ownerIdV1);
        }

        this.setState({
            deviceOwnersV2,
            deviceOwnersV1,
            devices: allDevices,
            loading: false,
        });
    };

    render() {
        const { devices, loading, deviceOwnersV2, deviceOwnersV1 } = this.state;

        const deviceOwners = new Map(
            [...deviceOwnersV2, ...deviceOwnersV1].filter(
                (it): it is [string, string] => !!it[1],
            ),
        );
        return (
            <>
                <Timer interval={10 * duration.second} onTick={this.onTick} />
                <TeleopList
                    onClose={this.props.onClose}
                    loading={loading}
                    devices={devices}
                    deviceOwners={deviceOwners}
                />
            </>
        );
    }
}
